import React from "react";
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

/**
 * @param {Products_Object} product
 * @param visible
 */
export default ({product, visible = false}) => {
	let maxCharacters = 16;
	let minCharacters = 5;
	let productId = product.id ? product.id : (product.binary_id + '-' + product.pkey);

	let cutBarCodeText = (text)=> {
		return text.substr(0, maxCharacters);
	};
	let cutBarCodeTextExtra = (text)=> {
		return ' ' + text.substr(maxCharacters);
	};
	let getBarCodeWidth = (text) => {
		let smallest = 1.6;
		let largest = 2.5;
		let range = largest - smallest;
		let charRange = maxCharacters - minCharacters;
		let widthSegmentPerCharacter = range / charRange;
		let charsOverMin = text.length - minCharacters;
		let additionalSize = widthSegmentPerCharacter * charsOverMin;
		let newSize = largest - additionalSize;
		return Math.min(Math.max(newSize, smallest), largest);
	};

	return (
		<div style={{
			width: 382,
			height: 220,
			textAlign: 'left',
			position: 'relative',
			padding: '2px 0 0',
			margin: '0',
			whiteSpace: 'nowrap',
			fontSize: '12px',
			lineHeight: 1.42857143,
			fontFamily: 'Arial, sans-serif',
			overflow: 'hidden',
			... visible ? {
				border: '1px solid black',
				borderRadius: '10px',
				display: 'inline-block'
			} : {
				pageBreakBefore: 'always'
			}
		}}>
			<div className={'nonosquare'} style={{
				border: '0px inset blue',
				margin: '4px 20px 0px',
				padding: '0 2px',
				height: 204,
				overflow: 'hidden'
			}}>
				<div style={{height: "100px"}}>
					{product.sku &&
							<div style={{right: 10, position: 'absolute'}}>
								<QRCode value={product.sku} size={64}/>
							</div>}
					<b>{cutBarCodeText(product.sku)}</b>{cutBarCodeTextExtra(product.sku)}<br/>
					Man / Imp : {!product.manufacturer_other && product.manufacturers ? product.manufacturers.name : product.manufacturer_other}
						{product.importer && <span> / {product.importer}</span>}<br/>
					Model : {product.model}<br/>
					Cal / Gauge : {!product.caliber_other && product.calibers ? product.calibers.name : product.caliber_other}<br/>
				</div>
				<div style={{height: '72px'}}>
					<div>
						S/N : <b>{cutBarCodeText(product.serial_number)}</b>{cutBarCodeTextExtra(product.serial_number)}
					</div>
					{product.serial_number &&
					<div style={{padding: 0, margin: 0}}>
						<Barcode
							format={'CODE128A'}
							value={cutBarCodeText(product.serial_number)}
							height={20}
							margin={0}
							width={getBarCodeWidth(product.serial_number)}
							displayValue={false}
						/>
					</div>}
					<div>
						Log # : <b>{cutBarCodeText(productId)}</b>{cutBarCodeTextExtra(productId)}
					</div>
					{/*<div>*/}
					{/*	<Barcode*/}
					{/*		format={'CODE128A'}*/}
					{/*		value={cutBarCodeText(productId)}*/}
					{/*		height={20}*/}
					{/*		margin={0}*/}
					{/*		width={getBarCodeWidth(productId)}*/}
					{/*		displayValue={false}*/}
					{/*	/>*/}
					{/*</div>*/}
				</div>
				<div>
					<div style={{fontSize: "16px"}}>
						S/N : {product.serial_number}
					</div>
				</div>
			</div>
		</div>
	);
};
